import {createStore, combineReducers, compose, applyMiddleware} from "redux";
import {loadState} from "./state";
import thunk from "redux-thunk";
import {persistStore, persistReducer} from "redux-persist";
import storage from "redux-persist/lib/storage";
import {users_module} from "./users";
import {provinces_module} from "./provinces";
import {cities_module} from "./cities";
import {zones_module} from "./zones";
import {stores_module} from "./stores";
import {teams_module} from "./teams";
import {user_types_module} from "./user_types";
import {assist_control_module} from "./assist_control";
import {users_stores_access_module} from "./stores_access";
import {critical_levels_module} from "./critical_levels";
import {work_sheets_module} from "./work_sheets";
import {periodicities_module} from "./periodicities";
import {work_process_module} from "./work_process";
import {work_subprocess_module} from "./work_subprocess";
import {work_activities_module} from "./work_activities";
import {work_activity_aditional_data_module} from "./work_activity_aditional_data";
import {work_activity_templates_module} from "./work_activity_templates";
import {work_subprocess_risks_module} from "./work_subprocess_risks";
import {observations_module} from "./observations";
import {result_states_module} from "./result_states";
import {activities_module} from "./activities";
import {responsibles_module} from "./responsibles";
import {findings_matrix_module} from "./findings_matrix";
import {societies_module} from "./societies";
import {update_activity_module} from "./update_activity";
import {risk_impact_module} from "./risk_impacts";


const rootReducer = combineReducers({
    users_module: users_module,
    provinces_module: provinces_module,
    cities_module: cities_module,
    zones_module: zones_module,
    stores_module: stores_module,
    teams_module: teams_module,
    user_types_module: user_types_module,
    assist_control_module: assist_control_module,
    users_stores_access_module: users_stores_access_module,
    critical_levels_module: critical_levels_module,
    work_sheets_module: work_sheets_module,
    periodicities_module: periodicities_module,
    work_process_module: work_process_module,
    work_subprocess_module: work_subprocess_module,
    work_activities_module: work_activities_module,
    work_activity_aditional_data_module: work_activity_aditional_data_module,
    work_activity_templates_module: work_activity_templates_module,
    work_subprocess_risks_module: work_subprocess_risks_module,
    observations_module: observations_module,
    result_states_module: result_states_module,
    activities_module: activities_module,
    responsibles_module: responsibles_module,
    findings_matrix_module: findings_matrix_module,
    societies_module: societies_module,
    update_activity_module: update_activity_module,
    risk_impact_module: risk_impact_module,
});

const persistConfig = {
    key: "root",
    storage,
};

const persistedReducer = persistReducer(persistConfig, rootReducer);
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

export const generateStore = () => {
    const initialData = loadState();

    const store = createStore(
        persistedReducer,
        initialData,
        composeEnhancers(applyMiddleware(thunk))
    );

    const persistor = persistStore(store, ["auth"]);

    return {store, persistor};
};
